import { Loader2 } from 'lucide-react';

import { cn } from '@/utils/cn';
import { usePriceIntelStore } from '../stores/price-intel-store';

const modeOptions = [
  { id: 'local', label: '本地' },
  { id: 'api', label: '在线' },
] as const;

export function PriceIntelModeSwitch() {
  const { mode, isLoading, setMode } = usePriceIntelStore();

  return (
    <div
      className="inline-flex items-center rounded-full border p-0.5"
      style={{
        borderColor: 'var(--color-system-quaternary)',
        backgroundColor: 'var(--color-background-secondary)',
      }}
    >
      {modeOptions.map((option) => {
        const isActive = option.id === mode;
        return (
          <button
            key={option.id}
            onClick={() => void setMode(option.id)}
            disabled={isLoading && !isActive}
            className={cn(
              'inline-flex min-w-[56px] items-center justify-center rounded-full px-3 py-1.5 text-xs font-medium transition',
            )}
            style={{
              backgroundColor: isActive ? 'var(--color-background-primary)' : 'transparent',
              color: isActive ? 'var(--color-system-primary)' : 'var(--color-system-secondary)',
              boxShadow: isActive ? 'var(--shadow-sm)' : 'none',
            }}
          >
            {isLoading && !isActive ? <Loader2 size={12} className="animate-spin" /> : option.label}
          </button>
        );
      })}
    </div>
  );
}
